import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import * as api from './top-terms'
import { ContentPiece } from './leader-board-graph'
import { IUser } from '@giphy/js-types'
import { singularContentTypes } from '../../../site/user-dashboard-analytics/app'

const Container = styled.div`
    span {
        color: #00baee; //NOTE: Color does not exist in brand repo
        text-transform: capitalize;
    }
    z-index: 2;
`

type Props = {
    item: ContentPiece
    contentType: string
    dateRange: string[]
    user: IUser
}

const Insight = ({ item, contentType, dateRange, user }: Props) => {
    const [topTerm, setTopTerm] = useState<string>('')
    const [count, setCount] = useState<number>(0)
    const [allowedToFetch, setAllowedToFetch] = useState<boolean>(true)

    useEffect(() => {
        // Connect to the api for top terms
        if (allowedToFetch) {
            chooseATopTerm(item, contentType, dateRange, user, true)
        }

        return () => {
            setAllowedToFetch(false)
        }
    }, [dateRange, item])

    const chooseATopTerm = async (item, contentType, dateRange, user, returnTopTerm) => {
        const data = await api.getTopTerms(user.token, contentType, dateRange, [item.contentId])
        // remove any terms that start with 'giphy'
        let filteredData = data.filter(function(item) {
            return !item.term.toLowerCase().startsWith('giphy')
        })
        // Were top terms returned at all?
        if (filteredData.length > 0) {
            if (returnTopTerm) {
                // sort filteredData by rank, since it's not necessarily returned that way
                filteredData.sort(function(a, b) {
                    return a.rank - b.rank
                })
                // If the 'returnTopTerm' flag is set, just set the top term and count.
                setTopTerm(filteredData[0].term)
                setCount(filteredData[0].impressionCount)
            } else {
                // Otherwise, randomize the results
                var randomTermObject = filteredData[Math.floor(Math.random() * filteredData.length)]
                setTopTerm(randomTermObject.term)
                setCount(randomTermObject.impressionCount)
            }
        }
    }

    return (
        <Container>
            {topTerm && count !== null && count !== undefined && contentType !== 'Stories' && (
                <div>
                    When users searched <span>{topTerm}</span>, they clicked your{' '}
                    {contentType !== 'GIFs & Stickers' ? singularContentTypes[contentType] : 'content'}{' '}
                    <span>{count.toLocaleString()}</span> times.
                </div>
            )}
        </Container>
    )
}

export default Insight
